import { render, staticRenderFns } from "./BBDropdown.vue?vue&type=template&id=a78305b0"
import script from "./BBDropdown.vue?vue&type=script&lang=js"
export * from "./BBDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a78305b0')) {
      api.createRecord('a78305b0', component.options)
    } else {
      api.reload('a78305b0', component.options)
    }
    module.hot.accept("./BBDropdown.vue?vue&type=template&id=a78305b0", function () {
      api.rerender('a78305b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/content/BBDropdown.vue"
export default component.exports